import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.scss'],
})
export class HowToComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {}

  startQuestions(){
    this.router.navigate(['/questionnaire/question']);
  }

}
